import authorizations from 'live/services/authorization'
import SeviceLocator from 'live/services/service-locator'
import { MessengerForm } from './components/activity-log-form'
import ActivityLogEventRenderer from './components/activity-log-event-renderer'
import ConfigForm from './components/activity-log-config-form'
import ExtensionService from 'live/services/extension'
import { Permission } from './utils'
import i18n from 'live/services/i18n'

try {
    document.addEventListener('DOMContentLoaded', function () {
        require('./init')
    })

    const config = {
        name: i18n('Activity Log'),
        url: '#/activity_log/config',
        alias: 'Activity LOG config',
        ico: 'fa fa-sticky-note',
        position: 'first-block',
        addRoute: true,
        routeUrl: 'activity_log/config',
        component: ConfigForm
    }

    if (authorizations.isAuthenticated) {
        SeviceLocator.getService('timeline-event-renderer-registry').then(service =>
            service.register(ActivityLogEventRenderer)
        )

        SeviceLocator.getService('messenger-event-renderer-registry').then(service =>
            service.register(ActivityLogEventRenderer)
        )

        if (Permission.canCreateActivityLog) {
            SeviceLocator.getService('timeline-form-registry').then(service => service.register(MessengerForm))
            SeviceLocator.getService('messenger-form-registry').then(service => service.register(MessengerForm))
        }

        if (Permission.isAdmin || Permission.viewAdmin) ExtensionService.addAdminMenu(config)
    }
} catch (e) {
    console.error(e)
}
